import { guid } from "@/utils/other.js";
import { toolsts } from "@/api";
import ObsClient from "esdk-obs-browserjs";
//上传阿里云
export async function uploadRequest(option) {

  return resUrl;
}
